<ng-container>
  <c-container [fluid]="true" class="px-4">
    <button
      [cSidebarToggle]="sidebarId"
      cHeaderToggler
      class="btn d-lg-none pe-3"
      toggle="visible"
      style="margin-inline-start: -14px;"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>

    <a
      routerLink="/dashboard"
      class="d-flex align-items-center text-decoration-none text-body flex-shrink-0 ms-0 ms-md-2 py-1"
      title="Registramed"
    >
      <img
        class="flex-shrink-0"
        src="assets/images/registramed-mark.svg"
        alt="Registramed"
        width="28"
        height="28"
      />
    </a>

    <div class="d-flex align-items-center flex-grow-1 min-width-0 ms-2 py-1">
      <c-breadcrumb-router class="mb-0 header-breadcrumb" />
    </div>

    <c-header-nav class="d-none d-md-flex ms-auto flex-shrink-0">
      <ng-container *ngTemplateOutlet="newsDropdown" />
      <ng-container *ngTemplateOutlet="notifyDropdown" />
    </c-header-nav>

    <c-header-nav class="ms-auto ms-md-0">
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
      <ng-container *ngTemplateOutlet="themeDropdown" />
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
    </c-header-nav>

    <c-header-nav class="ms-0">
      <ng-container *ngTemplateOutlet="userDropdown" />
    </c-header-nav>
  </c-container>
</ng-container>

<ng-template #userDropdown>
  <c-dropdown [popperOptions]="{ placement: 'bottom-start' }" variant="nav-item">
    <button [caret]="false" cDropdownToggle class="py-0" [attr.aria-label]="'Menú de usuario'">
      @if (avatarSrc(); as src) {
        <c-avatar
          size="md"
          [src]="src"
          status="success"
          textColor="primary"
        />
      } @else {
        <c-avatar size="md" color="primary" textColor="white">
          {{ userInitials() }}
        </c-avatar>
      }
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">
      @if (userLabel()) {
        <li>
          <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold py-2 rounded-top">
            {{ userLabel() }}
          </h6>
        </li>
      }
      <li>
        <a cDropdownItem routerLink="/mi-cuenta">
          <svg cIcon class="me-1" name="cilUser"></svg>
          Mi cuenta
        </a>
      </li>
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <button type="button" cDropdownItem (click)="logout()">
          <svg cIcon class="me-1" name="cilAccountLogout"></svg>
          Cerrar sesión
        </button>
      </li>
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #notifyDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle>
      <span class="d-inline-block my-1 mx-2 position-relative">
        <svg cIcon name="cilBell" size="lg"></svg>
        @if (showBellNotifications() && bellBadgeCount() > 0) {
          <c-badge
            class="p-1"
            color="danger"
            position="top-end"
            shape="rounded-circle"
          >{{ bellBadgeCount() }}<span class="visually-hidden"> alertas</span></c-badge>
        }
      </span>
    </button>
    <div cDropdownMenu class="p-0">
      @if (showBellNotifications()) {
        @if (canValidatePrestaciones()) {
          <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold rounded-top">
            <span>Prestaciones a revisar</span>
          </h6>
          @for (n of prestacionRecentAlerts(); track n.id) {
            <a cDropdownItem [routerLink]="['/prestaciones', n.id]" (click)="onPrestacionAlertClick(n.id)">
              <svg cIcon class="me-2 text-{{n.color}}" name="{{n.icon}}"></svg>
              {{ n.title }}
            </a>
          }
          @if (prestacionRecentAlerts().length === 0) {
            <div class="px-3 py-2 text-body-secondary small">
              Las prestaciones pendientes de revisión aparecerán aquí en tiempo real.
            </div>
          }
        }
        @if (canReadNotifications()) {
          <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold" [class.rounded-top]="!canValidatePrestaciones()">
            <span>Notificaciones del sistema</span>
          </h6>
          @if (unreadNotifCount() > 0) {
            <a cDropdownItem routerLink="/notificaciones">
              <svg cIcon class="me-2 text-info" name="cilBell"></svg>
              {{ unreadNotifCount() }} notificación(es) sin leer
            </a>
          } @else {
            <div class="px-3 py-2 text-body-secondary small">
              No hay notificaciones sin leer en tu bandeja.
            </div>
          }
          <hr class="dropdown-divider my-0"/>
          <button
            type="button"
            cDropdownItem
            class="text-center small py-2"
            (click)="goToAllNotifications()"
          >
            Ver todas las notificaciones
          </button>
        }
      } @else {
        <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold rounded-top">
          <span>Notificaciones</span>
        </h6>
        <div class="px-3 py-2 text-body-secondary small">Sin notificaciones para tu cuenta.</div>
      }
    </div>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle>
      @switch (colorMode()) {
        @case ("dark") {
          <svg cIcon name="cilMoon" size="lg"></svg>
        }
        @case ("auto") {
          <svg cIcon name="cilContrast" size="lg"></svg>
        }
        @default {
          <svg cIcon name="cilSun" size="lg"></svg>
        }
      }
    </button>
    <div cDropdownMenu>
      <button
        (click)="colorMode.set('light')"
        [active]="colorMode()==='light'"
        [routerLink]="[]"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" name="cilSun" size="lg"></svg>
        Claro
      </button>
      <button
        (click)="colorMode.set('dark')"
        [active]="colorMode()==='dark'"
        [routerLink]="[]"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" name="cilMoon" size="lg"></svg>
        Oscuro
      </button>
      <button
        (click)="colorMode.set('auto')"
        [active]="colorMode()==='auto'"
        [routerLink]="[]"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" name="cilContrast" size="lg"></svg>
        Automático
      </button>
    </div>
  </c-dropdown>
</ng-template>

<ng-template #newsDropdown>
  @if (newsBanners().length > 0) {
    <c-dropdown alignment="end" variant="nav-item">
      <button [caret]="false" cDropdownToggle title="Novedades">
        <span class="d-inline-block my-1 mx-2 position-relative">
          <svg cIcon name="cilBullhorn" size="lg"></svg>
          @if (newsUnseenCount() > 0) {
            <c-badge
              class="p-1"
              color="info"
              position="top-end"
              shape="rounded-circle"
            >
              <span class="visually-hidden">{{ newsUnseenCount() }} novedades</span>
            </c-badge>
          }
        </span>
      </button>
      <div cDropdownMenu class="p-0" style="min-width: 300px; max-width: 360px;">
        <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold rounded-top">
          Novedades ({{ newsBanners().length }})
        </h6>
        @for (b of newsBanners().slice(0, 4); track b.id) {
          <a cDropdownItem [routerLink]="['/noticias']" class="d-flex align-items-center gap-2 py-2">
            <div
              class="flex-shrink-0 rounded"
              [style.background-color]="b.color === 'primary' ? '#3b82f6' : b.color === 'info' ? '#38bdf8' : b.color === 'success' ? '#10b981' : b.color === 'warning' ? '#f59e0b' : '#ef4444'"
              style="width: 40px; height: 40px; overflow: hidden;"
            >
              @if (b.imageSignedUrl) {
                <img [src]="b.imageSignedUrl" alt="" style="width: 100%; height: 100%; object-fit: cover;" />
              }
            </div>
            <div class="min-width-0 flex-fill">
              <div class="fw-semibold small text-truncate">{{ b.title }}</div>
              <div class="text-body-secondary small text-truncate">{{ b.description }}</div>
            </div>
          </a>
        }
        @if (newsBanners().length > 4) {
          <div class="px-3 py-2 text-center">
            <a routerLink="/noticias" class="small text-primary text-decoration-none">
              Ver todas las novedades
            </a>
          </div>
        }
      </div>
    </c-dropdown>
  }
</ng-template>
